import ApplicationAdapter, { childMixin } from "./application";

export default class LoadBalancerTargetAdapter extends ApplicationAdapter.extend(childMixin) {
  parentAdapter = "load-balancer-listener";
  parentRelationship = "listener";
  parentSuffix = "targets";
}
